import Vue        from 'vue'

// input
// Vue.component('i-input'      , require('./i-input.vue'        ).default)
// Vue.component('i-input-date' , require('./i-input-date.vue'   ).default)
// Vue.component('i-input-sel'  , require('./i-input-sel.vue'    ).default)
// Vue.component('i-input-radio', require('./i-input-radio.vue'  ).default)
// Vue.component('i-chk'        , require('./i-chk.vue'          ).default)

// // btns
// Vue.component('i-btn'        , require('./i-btn.vue'          ).default)

// // 타이틀 바
// Vue.component('i-bar'        , require('./i-bar.vue'          ).default)
// Vue.component('i-bar-items'  , require('./i-bar-items.vue'    ).default)
// Vue.component('i-bar-btn'    , require('./i-bar-btn.vue'      ).default)

// Vue.component('i-radio-group', require('./i-radio-group.vue'  ).default)
// Vue.component('i-radio'      , require('./i-radio.vue'        ).default)
// Vue.component('i-checkbox'   , require('./i-checkbox.vue'     ).default)

// Vue.component('star'         , require('./star.vue'           ).default)
// Vue.component('s-wrapper'    , require('./s-wrapper.vue'      ).default)
// Vue.component('s-content'    , require('./s-content.vue'      ).default)
// Vue.component('s-editor'     , require('./s-editor.vue'       ).default)
// Vue.component('s-page'       , require('./s-page.vue'         ).default)
// Vue.component('s-table'      , require('./s-table.vue'        ).default)

// Vue.component('i-btn', require('@/components/i-btn/i-btn.vue' ).default)
// import Iinput     from '@/components/i-input.vue'
// Vue.component('i-input'  Iinput)
// Vue.component('i-input', import('@/components/i-input.vue').default )
// Vue.component('i-input', () => '@/components/i-input.vue')

// export default {
//   components: {
//     'i-input': Iinput
//   }
// }

// 현재 폴더에 있는 모든 .vue 파일들을 자동으로 글로벌 컴포넌트로 등록
// import upperFirst from 'lodash/upperFirst'
// import camelCase from 'lodash/camelCase'

import {upperFirst, camelCase} from 'lodash'

const requireComponent = require.context('.', false, /[\w-].vue$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName   = upperFirst(camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')))
  Vue.component(componentName, componentConfig.default || componentConfig)
})
